<div class="sub-menu menu-build">
    <a _ngcontent-hir-c279="" href="javscript:;" class="close-section ng-tns-c279-12 ng-star-inserted" (click)="closeMenu()"></a>
    <span *ngIf="this.compositeDesign">{{ selectedTitle }}</span>
    <ul class="sub-menu-content">
        <li *ngIf="this.zones">
            <div *ngFor="let zone of this.zones  | sortNumber: 'title': true" class="zone">
                <div class="zone-holder">
                    <h4 *ngIf="zone.title !== 'undefined' && zone.title !== ' '">{{zone.title}}</h4>
                    <div class="build" [class.current]="this.current === list.uid" *ngFor="let list of zone.list | rankingNum: 'ranking'">
                        <a *ngIf="!list.hideBuilding" href="javascript:;" (click)="viewBuildDetailsMenu(list)">
                            <!-- <a href="javascript:;" (click)="viewBuildDetailsMenu(list)"> -->
                            <div *ngIf="this.currentLanguage === 'he'" class="title">
                                {{ list.name }}
                            </div>
                            <div *ngIf="this.currentLanguage === 'en'" class="title">
                                {{ list.nameEn }}
                            </div>
                            <div class="text">
                                {{ list.freeText }}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>
